import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DatePickerE11Service {

  constructor() { }
}
